











































































import Vue from 'vue';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { iconsMixin } from '@/mixins/icons';
import DropdownOption from '@/models/misc/DropdownOption';
import countryService from '@/services/CountryService';
import locationsService from '@/services/LocationsService';

export default Vue.extend<any, any, any, any>({
    name: 'truck-quote-origin-information',
    mixins: [breakpointsMixin, iconsMixin],
    props: {
        value: {
            type: Object,
            required: true
        },
        showError: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            countriesDll: [] as DropdownOption[],
            origStatesDdl: [] as DropdownOption[],
            originMissingFields: [] as string[],
        };
    },
    computed: {
        originInfo: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        showOriginError: {
            get() {
                return this.showError;
            },
            set(value) {
                this.$emit('update:showError', value);
            }
        }
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            this.countriesDll = countryService.getAll();
            this.countryOrigChanged({ value: 'USA' });
        },
        countryOrigChanged(selected) {
            if (selected) {
                locationsService.getListOfStates(selected.value).then((x) => {
                    this.origStatesDdl = x.map(this.mapStates);
                });
            }
        },
        mapStates(state) {
            return new DropdownOption(state.name, state.id);
        },
        isValidPhoneNumber(phone: string): boolean {
            const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
            return phoneRegex.test(phone);
        },
        isValidZipCode(zipCode: string, country: string): boolean {
            if (!zipCode) return false;

            if (country === 'USA') {
                const usaZipRegex = /^\d{5}(-\d{4})?$/;
                return usaZipRegex.test(zipCode);
            } else if (country === 'CAN') {
                const canZipRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
                return canZipRegex.test(zipCode);
            }

            return true;
        },
        formatZipCode(zipCode: string, country: string): string {
            if (!zipCode) return zipCode;

            if (country === 'USA') {
                const cleaned = zipCode.replace(/\D/g, '');
                if (cleaned.length === 9) {
                    return `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
                }
                return cleaned.slice(0, 5);
            } else if (country === 'CAN') {
                const cleaned = zipCode.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
                if (cleaned.length === 6) {
                    return `${cleaned.slice(0, 3)} ${cleaned.slice(3)}`;
                }
                return cleaned;
            }

            return zipCode;
        },
        formatPhoneNumber(phone: string): string {
            const cleaned = phone?.replace(/\D/g, '');
            if (cleaned?.length !== 10) return phone;
            return `(${cleaned?.slice(0, 3)}) ${cleaned?.slice(3, 6)}-${cleaned?.slice(6)}`;
        },
        formatPhoneOnInput(event: Event) {
            const input = event.target as HTMLInputElement;
            const formatted = this.formatPhoneNumber(input?.value);
            if (formatted !== input?.value) {
                this.originInfo.contactPhone = formatted;
            }
        },
        formatZipOnInput(event: Event) {
            const input = event.target as HTMLInputElement;
            const formatted = this.formatZipCode(input?.value, this.originInfo.country);
            if (formatted !== input?.value) {
                this.originInfo.zipCode = formatted;
            }
        },
        validateBlock(): boolean {
            const missingFields: string[] = [];
            const info = this.value;
            if (!info.location) missingFields.push('Shipper Name');
            if (!info.contactName) missingFields.push('Contact Name');
            if (!info.country) missingFields.push('Country');
            if (!info.address) missingFields.push('Address');
            if (!info.city) missingFields.push('City');
            if (!info.state) missingFields.push('State/Province');
            if (!info.zipCode) {
                missingFields.push('Zip/Postal Code');
            } else if (!this.isValidZipCode(info.zipCode, info.country)) {
                if (info.country === 'USA') {
                    missingFields.push('Zip Code (must be in format 12345 or 12345-6789)');
                } else if (info.country === 'CAN') {
                    missingFields.push('Postal Code (must be in format A1A 1A1)');
                }
            }
            if (info.contactPhone && !this.isValidPhoneNumber(info.contactPhone)) {
                missingFields.push('Contact Phone (must be in format (XXX) XXX-XXXX)');
            }
            this.originMissingFields = missingFields;
            this.showOriginError = missingFields.length > 0;
            this.$emit('update:missingFields', missingFields);
            this.$emit('update:showError', missingFields.length > 0);
            return missingFields.length === 0;
        },
        handleStateSelection(event) {
            const selectedState = event.value;
            this.originInfo.state = selectedState;
        }
    },
    watch: {
        originInfo: {
            handler(newVal) {
                this.validateBlock();
            },
            deep: true
        },
        showError: {
            handler(newVal) {
                if (newVal) {
                    this.validateBlock();
                }
            }
        },
        'originInfo.country': {
            handler(newVal) {
                this.countryOrigChanged({ value: newVal });
            }
        }
    }
});
